const checkIfElementHasValue = element => {
	return element.value !== '' && element.value !== undefined && element.value !== null;
};

const checkIfElementHasPlaceholder = element => {
	return element.hasAttribute('placeholder') && element.getAttribute('placeholder').trim() !== '';
};

const addActiveClassToActiveElements = element => {
	if (checkIfElementHasValue(element) || checkIfElementHasPlaceholder(element)) {
		element.classList.add('is-active');
	} else {
		element.classList.remove('is-active');
	}
};

const umbracoFormsLabels = () => {
	document.querySelectorAll('.umbraco-forms-form input, .umbraco-forms-form select, .umbraco-forms-form textarea').forEach($element => {
		addActiveClassToActiveElements($element);
		$element.addEventListener('input', () => {
			addActiveClassToActiveElements($element);
		});
	});
};

const init = () => {
	umbracoFormsLabels();
};

module.exports = {
	init
};
